import eventEmitter from "./eventEmitter";

export const showModal = (...args) => eventEmitter.emit("showModal", args);
export const hideAllModals = () => eventEmitter.emit("hideAllModals");
export const removeModalByComponent = component =>
  eventEmitter.emit("removeModalByComponent", component);

export default showModal;
